<template>
<!-- 坐标组件 -->
<div>
    <el-form :inline="true" ref="ZBform"  :model="ZBform" :rules="rules"
     class="demo-form-inline jiaoyan" label-width="90px" size="mini">
   <div>
        <div class="">
          <!-- <el-form-item label="开始时间:" prop="shipMentTime">
                  <el-date-picker
                    v-model="rowData.shipMentTime"
                    value-format="timestamp"
                    type="datetime"
                      placeholder="选择日期时间"
                  ></el-date-picker>
            </el-form-item> -->
        </div>
        <div class="guiji">
           <el-timeline >
            <el-timeline-item
              v-for="(item, index) in ZBList"
              :key="index"
              color="#409EFF"
              :timestamp="item.coordinateTime|dateFormat">
              <span> 经纬度:{{item.longitude}}；{{item.latitude}}</span>
              <span v-if="rowData.shipStatus!=1301">
                 <i @click="editFn(item)"  class="el-icon-edit"></i>
                 <i @click="delFn(item)"  class="el-icon-delete"></i>
              </span>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div style="text-align: center;margin-top: 10px;"><el-button type="primary" v-if="rowData.shipStatus!=1301" @click="addFn">添加坐标</el-button></div>
        <!-- <div class="QDtiem">
          <el-form-item label="结束时间:" prop="shipMentTime">
                  <span v-if="rowData.shipStatus==3">{{rowData.updateTime|dateFormat}}</span>
                   <span v-if="rowData.shipStatus!=3">-</span>
            </el-form-item>
        </div> -->
        <el-dialog append-to-body :title="isAdd?'添加坐标':'修改坐标'" :visible.sync="addMark"  @close="closeDialog1" :close-on-click-modal="false" width="500px" center>
           <div class="inpBox">
             <el-form-item label="经度:" prop="nauticalLongitude">
              <el-input    placeholder=""  maxlength="20" v-model="ZBform.nauticalLongitude"></el-input>
            </el-form-item>
            <el-form-item label="纬度:" prop="nauticalLatitude">
              <el-input    placeholder="" maxlength="20" v-model="ZBform.nauticalLatitude"></el-input>
            </el-form-item>
            <el-form-item label="时间点:" prop="coordinateTimeFn" >
                    <el-date-picker
                      v-model="ZBform.coordinateTime"
                      value-format="timestamp"
                      type="datetime"
                        placeholder="选择日期时间"
                        @change="coordinateTimeFn"
                    ></el-date-picker>
              </el-form-item>
           </div>
         <span slot="footer" class="dialog-footer">
          <el-button @click="addMark=false">取消</el-button>
          <el-button type="primary" @click="addSave('ZBform')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    </el-form>
  </div>
</template>

<script>
import { shipCoordinateList, shipCoordinateListAdd, shipCoordinateUpdate, shipCoordinateDelete } from '@/api/shipping'
export default {
  name: 'D',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dialog: false,
      addMark: false,
      ZBform: {},
      ZBList: [],
      isAdd: true,
      rules: {
        longitude: [
          { required: true, message: '请输入经度', trigger: 'blur' }
        ],
        latitude: [
          { required: true, message: '请输入纬度', trigger: 'blur' }
        ],
        coordinateTime: [
          { required: true, message: '请选择时间点', trigger: 'blur' }
        ]
      }

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.dialog = true
    this.ZBform.shipDateId = this.rowData.id
    shipCoordinateList({ shipDateId: this.rowData.id }).then(res => {
      this.ZBList = res.list
    })
  },
  methods: {
    coordinateTimeFn () {
      var timestamp = new Date().getTime()
      if (this.ZBform.coordinateTime > timestamp) {
        this.$alert('时间点不能大于当前时间', '系统提示')
        this.$set(this.ZBform, 'coordinateTime', null)
      }
    },
    editFn (row) {
      this.ZBform = JSON.parse(JSON.stringify(row))
      this.ZBform.shipDateId = this.rowData.id
      // this.$set(this.ZBform, 'nauticalLongitude', row.longitude)
      // this.$set(this.ZBform, 'nauticalLatitude', row.latitude)
      this.addMark = true
      this.isAdd = false
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        shipCoordinateDelete({ shipDateId: this.rowData.id, id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          shipCoordinateList({ shipDateId: this.rowData.id }).then(res => {
            this.ZBList = res.list
            this.$emit('gengxin', res)
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    addFn () {
      var timestamp = new Date().getTime()
      this.$set(this.ZBform, 'coordinateTime', timestamp)
      this.addMark = true
      this.isAdd = true
    },
    addSave (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.isAdd) {
            shipCoordinateListAdd(this.ZBform).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.addMark = false
              shipCoordinateList({ shipDateId: this.rowData.id }).then(res => {
                this.ZBList = res.list
                this.$emit('gengxin', res)
              })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            shipCoordinateUpdate(this.ZBform).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.addMark = false
              shipCoordinateList({ shipDateId: this.rowData.id }).then(res => {
                this.ZBList = res.list
                this.$emit('gengxin', res)
              })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    closeDialog () {
      this.$emit('destroy')
    },
    closeDialog1 () {
      this.ZBform = {
        shipDateId: this.rowData.id
      }
    }
  },
  destroyed () {
    this.dialog = false
  }
}
</script>

<style scoped lang='less'>
.guiji{
  width: 95%;
  max-height:78vh ;
  border-top:1px dashed #ddd;
  overflow-y: auto;
  padding: 20px 10px;
}
.QDtiem{
 /deep/.el-date-editor .el-input__inner{
   border:none;
   padding: 0;
 }
 /deep/.el-input__icon{
   display: none;
 }
}
/deep/.inpBox .el-input__inner{
  width:180px;
}
/deep/.inpBox .el-form-item{
  display: flex;
  margin-bottom: 16px;
}
/deep/.el-icon-edit{
  margin: 0 8px;
  color: #0B25D6 ;
  font-size: 16px;
}
/deep/.el-icon-delete{
   color: #0B25D6 ;
   font-size: 16px;
}
</style>
